import type { IReview } from '@shared/common/data/products';

export const reviewsData: IReview[] = [
  {
    photoImgSrc: 'assets/images/FK_AP_review1.png',
    text: [
      `絵本には写真やアンパンマンたちがたくさんで、ひなちゃんも嬉しそう! <br> 寝る前まで何回もこれ読んでって持ってきて、お気に入りの1冊になりました🎀<br>心があったまる内容で絵もかわいくて癒されるので、ママやパパにとっても大切な宝物です。<br><br>(アンパンマンバースデーブック)`,
    ],
  },
  {
    photoImgSrc: 'assets/images/FK_AP_review2.png',
    text: [
      `アンパンマンデザインの箱に大興奮 ... ！<br>箱が飾り棚になるので作るのも楽しみです。<br>ロウソクのキャラクターや写真を一緒に選べて特別感があり、" はるくんの！" と大喜び♪<br>特に最後のページにあるやなせたかし先生の温かいお言葉が好きです😌<br><br>(アンパンマンバースデーブック)`,
    ],
  },
  {
    photoImgSrc: 'assets/images/FK_AP_review3.jpg',
    text: [
      `主人公のアバターを作成してお名前を入れたり写真やメッセージを入れる事が出来るから、特別感が得られる絵本でした☺️✨<br>今はまだひらがなは覚えれていないけど、これからこの本で楽しく覚えてくれそうだなと思いました👍✨<br><br>(おなまえさがして あいうえおもちゃごう)`,
    ],
  },
  {
    photoImgSrc: 'assets/images/FK_AP_review4.jpg',
    text: [
      `ページに散りばめられた、ひらがなの中から「おなまえの文字を探してみよう！」と、絵探しのワクワク感もあって、親子で一緒に楽しめました😄<br>ぼくが主人公なんだ！と目を輝かせる姿に、絵本の力を改めて感じました✨<br><br>(おなまえさがして あいうえおもちゃごう)`,
    ],
  },
  {
    photoImgSrc: 'assets/images/FK_AP_review5.png',
    text: [
      `最近アンパンマンにハマってる娘はすぐに見つけて指さしてたよ🤭<br>身長を入れられるところになると「なんだろう？」と眺めていたから頭触って身長のことだよって教えてあげたら自分の頭ポンポンして理解したみたい🤭<br>ママは懐かしみながら、娘は自分のことを知りながら読めて素敵でした🎂<br><br>(アンパンマンバースデーブック)`,
    ],
  },
  {
    photoImgSrc: 'assets/images/FK_AP_review6.jpg',
    text: [
      `最後のページの七五三の写真を見つけて大喜びの姉妹2人😂👘<br>可愛いイラストと、50音全てに触れられるハラハラドキドキ楽しい冒険ストーリーに目がキラキラ🥹<br>素敵な絵本、これからも大切にしたいな✨<br><br>(おなまえさがして あいうえおもちゃごう)`,
    ],
  },
  {
    photoImgSrc: 'assets/images/FK_AP_review7.jpg',
    text: [
      'この絵本は、専用のサイトから子供の名前や写真やメッセージを入れるだけで、世界でたった一つの絵本ができます📙💖<br>絵本に出てくるキャラクターは、表情豊かで可愛くてイラストもカラフルなので、一緒に見てる大人も癒されました🚂<br><br>(おなまえさがして あいうえおもちゃごう)',
    ],
  },
  {
    photoImgSrc: 'assets/images/FK_AP_review8.jpeg',
    text: [
      '絵本には出生時間や身長体重、メッセージも入れられて、ずっと記念に残る1冊になります！WEBで入力だからプレゼントにもいいかも！<br>何枚も写真が入れられるのもすごい嬉しいポイントでした！！<br>一緒に懐かしみながら読める日が楽しみ♪<br><br>(アンパンマンバースデーブック)',
    ],
  },
  {
    photoImgSrc: 'assets/images/FK_AP_review9.jpg',
    text: [
      `可愛いイラストの専用箱が届き、見た瞬間から 「これ なにー♡!?」と大喜び🤩<br>平仮名や可愛いイラストが描いてあり、「これぬり絵じゃない？」と嬉しそうに色ぬりを始めました！自分の名前と、家族の名前の文字を探してぬってくれました♡<br><br>(おなまえさがして あいうえおもちゃごう)`,
    ],
  },
  {
    photoImgSrc: 'assets/images/FK_AP_review10.png',
    text: [
      '写真を選ぶと絵本のプレビューが見れます📖<br>「このページは絶対にこの写真がいい！」「やっぱり他の写真がいいかな？」と悩むのも楽しかったです☺️<br>いつか、「3歳の誕生日にもらった絵本だ」「あの頃はアンパンマンが好きだったな」と思い出してくれたらうれしいです。<br><br>(アンパンマンバースデーブック)',
    ],
  },
];
export const reviewsDataTKBook1: IReview[] = [
  {
    photoImgSrc: 'assets/images/FK_bk1_review1.png',
    text: [
      `絵本には写真やアンパンマンたちがたくさんで、ひなちゃんも嬉しそう!<br>寝る前まで何回もこれ読んでって持ってきて、お気に入りの1冊になりました🎀<br>心があったまる内容で絵もかわいくて癒されるので、ママやパパにとっても大切な宝物です。`,
    ],
  },
  {
    photoImgSrc: 'assets/images/FK_bk1_review2.png',
    text: [
      `アンパンマンデザインの箱に大興奮 ... ！<br>箱が飾り棚になるので作るのも楽しみです。<br>ロウソクのキャラクターや写真を一緒に選べて特別感があり、" はるくんの！" と大喜び♪<br>特に最後のページにあるやなせたかし先生の温かいお言葉が好きです😌`,
    ],
  },
  {
    photoImgSrc: 'assets/images/FK_bk1_review3.png',
    text: [
      `最近アンパンマンにハマってる娘はすぐに見つけて指さしてたよ🤭<br>身長を入れられるところになると「なんだろう？」と眺めていたから頭触って身長のことだよって教えてあげたら自分の頭ポンポンして理解したみたい🤭<br>ママは懐かしみながら、娘は自分のことを知りながら読めて素敵でした🎂`,
    ],
  },
  {
    photoImgSrc: 'assets/images/FK_bk1_review4.jpeg',
    text: [
      `絵本には出生時間や身長体重、メッセージも入れられて、ずっと記念に残る1冊になります！WEBで入力だからプレゼントにもいいかも！<br>何枚も写真が入れられるのもすごい嬉しいポイントでした！！<br>一緒に懐かしみながら読める日が楽しみ♪`,
    ],
  },
  {
    photoImgSrc: 'assets/images/FK_bk1_review5.png',
    text: [
      `スマホ1台でとっても簡単に作れちゃいます😳<br>子どもの記録やお気に入りの写真を入れるだけで思い出に残る1冊が出来上がります✨<br><br>お孫さんなどへのプレゼントにもぴったりの絵本ですよ☺️`,
    ],
  },
  {
    photoImgSrc: 'assets/images/FK_bk1_review6.png',
    text: [
      `写真を選ぶと絵本のプレビューが見れます📖<br>「このページは絶対にこの写真がいい！」「やっぱり他の写真がいいかな？」と悩むのも楽しかったです☺️<br>いつか、「3歳の誕生日にもらった絵本だ」「あの頃はアンパンマンが好きだったな」と思い出してくれたらうれしいです。`,
    ],
  },
  {
    photoImgSrc: 'assets/images/FK_bk1_review7.png',
    text: [
      `絵本の内容もすごくボリュームがあるし、登場するキャラクターも選べるところがあるよ！<br><br>ギフトコードとして贈ることもできるんだって❣️<br><br>親子でこの絵本は宝物になりました！<br>とっても素敵な3歳の誕生日プレゼントになって<br>うれしいです😌♡`,
    ],
  },
  {
    photoImgSrc: 'assets/images/FK_bk1_review8.png',
    text: [
      `絵も文章も素敵すぎる！<br>何年経っても絵本は愛され続けるもの。<br>写真が入れられるので、アルバム代わりになって素敵でした😌`,
    ],
  },
  {
    photoImgSrc: 'assets/images/FK_bk1_review9.jpeg',
    text: [
      `思い出になる絵本にひーちゃんも大喜び😆<br>お兄ちゃんの誕生日にもプレゼントしようかな！<br><br>成長が一目で分かるし、メッセージも絵本の中に入れられるから一生大切にしたい🎁`,
    ],
  },
  {
    photoImgSrc: 'assets/images/FK_bk1_review10.png',
    text: [
      `世界にひとつだけの絵本 📖<br><br>写真入れたりメッセージ入れたりできて作らせてもらって すぐ届いた 🚚📦<br><br>自分の写真や、おとの大好きなアンパンマンがいっぱいで嬉しそうにみてました😌`,
    ],
  },
];
export const reviewsDataTKBook2: IReview[] = [
  {
    photoImgSrc: 'assets/images/FK_bk2_review1.jpg',
    text: [
      `主人公のアバターを作成してお名前を入れたり写真やメッセージを入れる事が出来るから、特別感が得られる絵本でした☺️✨<br>今はまだひらがなは覚えれていないけど、これからこの本で楽しく覚えてくれそうだなと思いました👍✨`,
    ],
  },
  {
    photoImgSrc: 'assets/images/FK_bk2_review2.jpg',
    text: [
      `ページに散りばめられた、ひらがなの中から「おなまえの文字を探してみよう！」と、絵探しのワクワク感もあって、親子で一緒に楽しめました😄<br>ぼくが主人公なんだ！と目を輝かせる姿に、絵本の力を改めて感じました✨`,
    ],
  },
  {
    photoImgSrc: 'assets/images/FK_bk2_review3.jpg',
    text: [
      `最後のページの七五三の写真を見つけて大喜びの姉妹2人😂👘<br>可愛いイラストと、50音全てに触れられるハラハラドキドキ楽しい冒険ストーリーに目がキラキラ🥹<br>素敵な絵本、これからも大切にしたいな✨`,
    ],
  },
  {
    photoImgSrc: 'assets/images/FK_AP_review7.jpg',
    text: [
      `この絵本は、専用のサイトから子供の名前や写真やメッセージを入れるだけで、世界でたった一つの絵本ができます📙💖<br>絵本に出てくるキャラクターは、表情豊かで可愛くてイラストもカラフルなので、一緒に見てる大人も癒されました🚂`,
    ],
  },
  {
    photoImgSrc: 'assets/images/FK_bk2_review5.jpg',
    text: [
      `可愛いイラストの専用箱が届き、見た瞬間から 「これ なにー♡!?」と大喜び🤩<br>平仮名や可愛いイラストが描いてあり、「これぬり絵じゃない？」と嬉しそうに色ぬりを始めました！自分の名前と、家族の名前の文字を探してぬってくれました♡`,
    ],
  },
  {
    photoImgSrc: 'assets/images/FK_bk2_review6.jpg',
    text: [
      `この絵本は、世界でたったひとつの名前入り絵本です✨<br>自分が主人公だから、子どもにとって特別な1冊になること間違いなしです😍<br>息子も表紙を見た瞬間に｢え！なんで名前書いてるん！？｣とすごーく嬉しそうにしていました🥰`,
    ],
  },
  {
    photoImgSrc: 'assets/images/FK_bk2_review7.jpg',
    text: [
      `1番いいなと思ったのは最後に写真と名前の由来などのメッセージが入れられること。<br>写真がある事でグッと自分のもの感が出るし、名前の由来をちゃんと文章にしてあげるって、親としても初心にかえるし自己肯定感にも繋がると思いました😌`,
    ],
  },
  {
    photoImgSrc: 'assets/images/FK_bk2_review8.jpg',
    text: [
      `自分の名前を探すのも楽しいようですが、ストーリー自体が面白くて息子はもちろん娘も一緒に楽しんでくれています。<br>兄妹揃って乗り物が大好きなので、読んでー！とよく持ってきてくれるようになりました🎵`,
    ],
  },
  {
    photoImgSrc: 'assets/images/FK_bk2_review9.jpg',
    text: [
      `こちらの絵本はストーリーを楽しみながら、自分が入り込んで気づいたらあいうえおに触れられるので、同じように書いてみるとか、自分が評価されている？と感じるようなやり方が苦手な娘みたいなタイプの子にもピッタリの絵本だと思います☺️`,
    ],
  },
  {
    photoImgSrc: 'assets/images/FK_bk2_review10.jpg',
    text: [
      `名前を入れたり、アバターを作って自分だけの特別な絵本を作ることができました！<br>親子でページをめくる時間も、届いた日のワクワクも、たくさんつまった素敵な絵本です😊📕✨️<br>記念日や誕生日のギフトにもオススメです☺️`,
    ],
  },
];
